import { Component, Prop, State, Watch, h } from '@stencil/core';

import { generateYMMString } from '../../../utils/utils.dynamic-entry';
import { DynamicEntryWorkflow } from '../../../utils/utils.landing';

@Component({
  tag: 'dynamic-entry-car-info',
  styleUrl: 'dynamic-entry-car-info.css',
})
export class DynamicEntryCarInfo {
  @Prop() year: number = 0;
  @Prop() vin: string = '';
  @Prop() make: string = '';
  @Prop() model: string = '';
  @Prop() trim: string = '';
  @Prop() currentSelectedTab: string = '';

  @Prop() hasMultipleTrims: boolean = false;
  @Prop() isFormSelectorStep: boolean = false;
  @Prop() dynamicEntryWorkflow: DynamicEntryWorkflow = DynamicEntryWorkflow.Unassigned;

  @State() displayedYmm: string = '';
  @State() displayedVin: string = '';

  @Watch('isFormSelectorStep')
  componentWillLoad() {
    this.displayedVin = this.vin;
    this.updateYmm();
  }

  updateYmm() {
    this.displayedYmm = generateYMMString({
      yearId: this.year,
      make: this.make,
      model: this.model,
      trim: this.hasMultipleTrims && this.currentSelectedTab !== 'ymm' ? '' : this.trim,
    });
  }

  renderVinInfo() {
    if (this.dynamicEntryWorkflow === DynamicEntryWorkflow.Unassigned) {
      if (this.isFormSelectorStep && !this.displayedVin) {
        return <div>Please enter your VIN or License Plate to move forward.</div>;
      }
    }
    if (!this.isFormSelectorStep && this.displayedVin) {
      return (
        <div class="text-xs" data-testid="ci-vin-text">
          VIN: {this.displayedVin}
        </div>
      );
    }
  }

  render() {
    const isOnYmmTab = this.isFormSelectorStep && this.currentSelectedTab === 'ymm';
    const hasYmm = this.displayedYmm.length > 0;

    if (!hasYmm || isOnYmmTab) {
      return;
    }

    const containerClass = {
      '-mt-2': true,
      'mb-4 space-y-1': !this.displayedVin,
      'mb-2 space-y-4': !!this.displayedVin,
    };

    return (
      <div class={containerClass}>
        <div class="font-extrabold text-xl leading-7 capitalize" data-testid="ci-year-make-model-text">
          {this.displayedYmm}
        </div>
        {this.renderVinInfo()}
      </div>
    );
  }
}
